export default __webpack_public_path__ + "static/media/3.702c1d37.png";